$('.billboard-slider').slick({
	arrows: false,
	autoplay: true
});